import React, { createContext, useContext, useEffect, useState } from 'react';

const NotificationContext = createContext([]);

export function NotificationProvider({ children }) {
  const [anchorId, setAnchorId] = useState();
  const [amountNotifications, setAmountNotifications] = useState(0);
  const [fetchNotification, setFetchNotification] = useState(false);
  const [canShowNotification, setCanShowNotification] = useState(false);

  const contextValues = {
    amountNotifications,
    anchorId,
    canShowNotification,
    fetchNotification,
    setAmountNotifications,
    setAnchorId,
    setCanShowNotification,
    setFetchNotification,
  };

  return (
    <NotificationContext.Provider value={contextValues}>{children}</NotificationContext.Provider>
  );
}

export function useNotification() {
  return useContext(NotificationContext);
}
